import { render, staticRenderFns } from "./Seccion_datos_de_envio.vue?vue&type=template&id=2f8b7af0&lang=pug&"
import script from "./Seccion_datos_de_envio.vue?vue&type=script&lang=js&"
export * from "./Seccion_datos_de_envio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports